export { default } from "./InfoBar";
